<div class="panel-transparent">
    <div vectormap [mapHeight]="200" [mapName]="mapName" [seriesData]="seriesData" [markersData]="markersData" [mapOptions]="mapOptions" ></div>
</div>